import { get } from 'svelte/store';
import { ConfigStore } from '../../store/config';
import { trackedFetch } from '../../telemetry/tracked-fetch';

export interface IAttachmentUploadResponse {
  id: string;
  content_type: string;
  size: number;
}

export async function postAttachment(
  file: File
): Promise<IAttachmentUploadResponse> {
  const config = get(ConfigStore);
  const url = new URL(`${config.apiBaseUrl}/1/attachment`);
  const tenantId = config.serverConfig?.tenant_id;
  if (tenantId) url.searchParams.set('tenant', tenantId);

  const body = new FormData();
  body.append('file', file);

  const response = await trackedFetch(tenantId ?? '', url.href, {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw response;
  }

  return response.json();
}
